<template>
    <Promised :promise="promise" :pending-delay="null">
        <template v-slot:pending="priorData">
            <slot key="1" name="pending" v-bind:pending="priorData" v-bind="$attrs">
                <LoadingWheel :width="100" v-bind="$attrs" />
            </slot>
        </template>
        <template v-slot:rejected="error">
            <slot key="2" name="rejected" v-bind:rejected="error" v-bind="$attrs">
                <h1 v-bind="$attrs">An error occurred</h1>
            </slot>
        </template>
        <template v-slot="data">
            <slot key="3" v-bind="{ ...$attrs, ...data }">
                <span style="display: none !important"></span>
            </slot>
        </template>
    </Promised>
</template>
<script lang="ts">
import { defineComponent, computed, watch } from "vue";
import { Promised } from "./Promised";
import LoadingWheel from "./LoadingWheel.3.vue";
const rethrowErrors = false;
export default defineComponent({
    components: {
        Promised,
        LoadingWheel,
    },
    inheritAttrs: false,
    props: {
        promise: Promise,
    },
    setup(props: { promise: Promise<unknown> | null | undefined }) {
        const promiseWrapped = computed(() => props.promise ?? new Promise(() => {}));
        if (rethrowErrors) {
            watch(
                () => promiseWrapped.value,
                () => {},
            );
        }
        return {
            promiseWrapped,
        };
    },
});
</script>
